import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {IntlProvider} from 'react-intl';
import {BrowserRouter} from 'react-router-dom';
import ConfigureStore from './store/ConfigureStore';
import App from './App';
import './semantic/dist/semantic.min.css';

const store = ConfigureStore();

ReactDOM.render(<Provider store={store}>
  <IntlProvider locale={navigator.language}>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </IntlProvider>
</Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js